import { render, staticRenderFns } from "./MinimalBgLayout.vue?vue&type=template&id=75d8f63a&"
import script from "./MinimalBgLayout.vue?vue&type=script&lang=js&"
export * from "./MinimalBgLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports